import { render, staticRenderFns } from "./ServiceBlock.vue?vue&type=template&id=4e3a34a4&scoped=true&"
import script from "./ServiceBlock.vue?vue&type=script&lang=js&"
export * from "./ServiceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a34a4",
  null
  
)

export default component.exports